export default {
    sendAuthRequest(vm) {
        axios
            .post("/assistance/login", {
                email: vm.email,
                password: vm.password
            })
            .then(response => {
                // success
                if (response.data.status) {
                    window.location.href = "/assistance/home";
                } else {
                    vm.errorMessage = response.data.mensagem;
                    this.changeBtnSubmitText("login");
                }
                // error
            })
            .catch(function(error) {
                vm.changeBtnSubmitText("login");
            });
    }
};
